module.exports = __webpack_public_path__ + "static/media/barbed_Wire.90ab51a6.webp";